import { Icon, Panel, PanelType, Toggle } from 'office-ui-fabric-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component } from 'react';
import { DataChecklistItem_Operation } from '../../data/DataChecklistItem_Operation';
import { Immocom } from '../../specifique/immocom';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheChecklistItems_Operation extends Component {

    static defaultProps = {
        idOperation: 0,
        /* --- */
        onDismiss: (rechargerLesDonnees) => null,
        onEnregistrement: () => null
    };

    static defaultState = {
        checklistItemsGroups: {},
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheChecklistItems_Operation.defaultState };
    };

    _chargementDonnees = () => {
        const { idOperation } = this.props;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement de la checklist en cours..."
        });

        DataChecklistItem_Operation._chargementChecklistItems_Operation(idOperation).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const items = responseFetch.reponseAPIobjet || [];
                const checklistItemsGroups = items.reduce((memo, item) => {
                    const libelleRegroupement = item.libelleRegroupement || "Sans catégorie";
                    if (!memo[libelleRegroupement])
                        memo[libelleRegroupement] = [];
                    memo[libelleRegroupement].push(item);
                    return memo;
                }, {});
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { checklistItemsGroups });
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _mettreAJour = (checklistItem) => () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Mise à jour en cours..."
        });

        DataChecklistItem_Operation._onEnregistrementChecklistItem_Operation(checklistItem)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };

    _onOpen = () => {
        this.setState({ ...FicheChecklistItems_Operation.defaultState }, this._chargementDonnees);
    };

    _onRenderFooterContent = () => {
        return <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>;
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { checklistItemsGroups } = this.state;

        const renderGroups = () => {
            const rows = [];
            if (!!checklistItemsGroups) {
                Object.entries(checklistItemsGroups).forEach(([libelleRegroupement, group], index) => {
                    if (!!group && group.length > 0) {
                        rows.push(<div key={index} className="ms-Grid-row"><div className="ms-Grid-col ms-sm12 mt-4 mb-2"><b>{libelleRegroupement}</b></div></div>);
                        group.forEach((checklistItem, i) => {
                            const { libelle, obligatoire, obtenu } = checklistItem;
                            rows.push(<div key={`${index}-${i}`} className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm8">{libelle}</div>
                                <div className="ms-Grid-col ms-sm2"><Toggle checked={obligatoire} onChange={this._mettreAJour({ ...checklistItem, obligatoire: !obligatoire })} /></div>
                                <div className="ms-Grid-col ms-sm2"><Toggle checked={obtenu} onChange={this._mettreAJour({ ...checklistItem, obtenu: !obtenu })} /></div>
                            </div>);
                        });
                    }
                });
            }
            return rows;
        };

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText="Checklist"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.medium}
        >

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack>

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row ms-hiddenMdDown" style={{ background: "white", position: "sticky", top: 0, zIndex: 100 }}>
                        <div className="ms-Grid-col ms-sm8" />
                        <div className="ms-Grid-col ms-sm2"><b>Obligatoire</b></div>
                        <div className="ms-Grid-col ms-sm2"><b>Obtenu</b></div>
                    </div>
                    <div className="ms-Grid-row ms-hiddenLgUp" style={{ background: "white", position: "sticky", top: 0, zIndex: 100 }}>
                        <div className="ms-Grid-col ms-sm8" />
                        <div className="ms-Grid-col ms-sm2" style={{ textAlign: "center" }}><Icon iconName="Asterisk" styles={{ root: { color: "red" } }} /></div>
                        <div className="ms-Grid-col ms-sm2" style={{ textAlign: "center" }}><Icon iconName="CheckMark" /></div>
                    </div>
                    {renderGroups()}
                </div>

            </Stack>

        </Panel>;

    };

};